import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { FormControl } from '@angular/forms';
import moment from 'moment';
declare var $: any;

@Component({
	selector: 'app-pharma-master',
	templateUrl: './pharma-master.component.html',
	styleUrls: ['./pharma-master.component.scss', '../../assets/styles/dashboard-styles.scss']
})
export class PharmaMasterComponent implements OnInit, AfterViewInit, OnDestroy {
	user_type: any = "";
	accessLoader = false;
	pagetitle = "Pharma-Master";
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: this.apiService.getDashboardURL("pharmaMaster"),
			name: this.pagetitle
		}
	];
	currentAccordion = "PharmaMaster";
	getYearList() {
		let yyyy = moment().year();
		let yearList: any[] = [];
		for (let i = 0; i < 10; i++) {
			yearList.push({ value: yyyy, name: yyyy });
			yyyy -= 1;
		}
		return yearList;
	}
	yearList: any[] = this.getYearList();

	cardsFilter: any = {
		company_id: null,
		year: moment().year(),
		subscription_status: "Subscribed"
	}

	getFilters() {
		const filters: any = {
			company_id: this.cardsFilter.company_id ? this.cardsFilter.company_id.pharma_id : null,
			year: this.cardsFilter.year,
			subscription_status: this.cardsFilter.subscription_status
		};
		return filters;
	}

	constructor(private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) { }
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.accessLoader = true;
			this.apiService.getUserAccess().subscribe({
				next: (data: any) => {
					this.accessLoader = false;
					try {
						this.user_type = data.res[0].user_type;
						if (sessionStorage.getItem("selectedCompanyFilter")) {
							try {
								let obj = JSON.parse(sessionStorage.getItem("selectedCompanyFilter")!);
								if (obj.pharma_id) {
									this.cardsFilter.company_id = obj;
								}
							} catch (error) { }
						}
						this.dashboard_company_dropdown();
						this.getInvoiceModuleAlerts();
					} catch (error) { }
				}, error: (error: any) => {
					this.accessLoader = false;
				}
			});
		});
	}

	ngAfterViewInit(): void { }

	ngOnDestroy(): void { }

	companyList_dropdown: any = [];
	dashboard_company_dropdown() {
		this.apiService.getCompanyDetails({}).subscribe({
			next: (data: any) => {
				data.data = data.data.filter((comp: any) => comp.pharma_id)
				this.companyList_dropdown = data.data;
			}, error: (error) => {
				this.companyList_dropdown = [];
			}
		});
	}

	setCompany(comp: any) {
		if (comp) {
			sessionStorage.setItem("selectedCompanyFilter", JSON.stringify(comp));
		} else {
			sessionStorage.removeItem("selectedCompanyFilter");
		}
	}

	filterChanged() {
		this.getInvoiceModuleAlerts();
	}

	masterData: any[] = [];
	loadingMasterData = false;
	masterDataExcelLoader = false;
	masterDataExcelName = "Pharma-Master.xlsx";
	masterDataHeaderName = "Pharma-Master";
	getInvoiceModuleAlerts() {
		const payload = this.getFilters();
		if (!payload.subscription_status) {
			this.toastr.warning("Please select subscription status", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (!payload.year) {
			this.toastr.warning("Please select year", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		this.loadingMasterData = true;
		this.apiService.getPharmaMaster(payload).subscribe({
			next: (data: any) => {
				this.loadingMasterData = false;
				this.masterData = data.data;
			}, error: (error) => {
				this.loadingMasterData = false;
				this.masterData = [];
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getInvoiceModuleAlertsExcel(e: any) {
		e.stopPropagation();
		const payload = this.getFilters();
		if (!payload.subscription_status) {
			this.toastr.warning("Please select subscription status", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		if (!payload.year) {
			this.toastr.warning("Please select year", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		this.masterDataExcelLoader = true;
		this.apiService.getPharmaMasterExcel(payload).subscribe({
			next: res => {
				let excelData: any = res.body;
				this.masterDataExcelLoader = false;
				let blob = new Blob([excelData], { type: "application/ms-excel" });
				let fileName = this.masterDataExcelName;
				FileSaver.saveAs(blob, fileName);
			}, error: (error) => {
				this.masterDataExcelLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to download excel", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}
}
